import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, Inject, Input, OnInit, Output, PLATFORM_ID } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';
import { Icons } from '../../../shared/helpers/icons';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { EventEmitter } from '@angular/core';
import { UserDataService } from '../../../shared/services/auth/userData.service';

@Component({
  selector: 'large-sidebar',
  standalone: true,
  imports: [
    CommonModule,
    LucideAngularModule
  ],
  templateUrl: './large-sidebar.component.html',
  styleUrl: './large-sidebar.component.css'
})
export class LargeSidebarComponent implements OnInit {
  icons = Icons;
  pageRoute: string = '';

  @Input() sidebarStatus: string = '';  
  @Output() sidebarStatusChange = new EventEmitter<string>();

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private userDataService: UserDataService
  ) { }

  ngOnInit(): void {    
    if (isPlatformBrowser(this.platformId)) {
      if (localStorage.getItem("assess_building_id")) { // get building Id from local storage
        const buildingId = localStorage.getItem("assess_building_id");
        this.userDataService.setBuildingId(buildingId + ""); // set building Id from local storage
      }
    }

    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
      this.updatePageRoute();
    });
    this.updatePageRoute();
  }

  private updatePageRoute() {
    this.pageRoute = this.activatedRoute.snapshot.firstChild?.routeConfig?.path ?? this.router.url.split('/')[1];
  }  
  
  navigateToPage(route: string): void {
    this.router.navigate([route]);
  }
  
  toggleSidebar(): void {
    this.sidebarStatus = this.sidebarStatus === 'large' ? 'small' : 'large';
    this.sidebarStatusChange.emit(this.sidebarStatus);
  }

}
